@if (typeSelectItems && typeSelectItems.length) {
  <p-dropdown
    (ngModelChange)="onChange($event)"
    [options]="typeSelectItems"
    [(ngModel)]="selection"
    [disabled]="disabled"
    [showClear]="enableEmpty"
    placeholder="auswählen..."
    optionLabel="name"
    dataKey="_id">
    <ng-template let-item pTemplate="selectedItem">
      <div class="flex align-items-center gap-2">
        <app-data-layer-type-name [dataLayerType]="item" />
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      @if (!displayNewLayerTypeOption && canAdd) {
        <div class="p-2 border-bottom-1 surface-border">
          <p-button
            [text]="true"
            [rounded]="true"
            (onClick)="openLayerTypeForm()"
            icon="fas fa-plus"
            label="hinzufügen"></p-button>
        </div>
      }
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <app-data-layer-type-name [dataLayerType]="item" />
      </div>
    </ng-template>
  </p-dropdown>
} @else {
  {{ noTypesAvailableMsg }}
}

@if (!displayNewLayerTypeOption && canAdd) {
  <p-dialog
    styleClass="z-top"
    maskStyleClass="z-top"
    appendTo="body"
    [modal]="true"
    [(visible)]="addNewLayerTypeDialog"
    [style]="{ width: '48rem' }">
    <ng-template pTemplate="header">
      <app-header
        styleClass="m-0"
        icon="fas fa-plus-circle"
        text="Raum hinzufügen"></app-header>
    </ng-template>
    @if (addNewLayerTypeDialog) {
      <app-data-layer-type-form
        [disableCancelLink]="true"></app-data-layer-type-form>
    }
  </p-dialog>
}
